// Dashboard Page
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
} from '@mui/material';
import {
  Add,
  Feedback,
  Article,
  RocketLaunch,
} from '@mui/icons-material';
import { useAuth } from '@/contexts/AuthContext';
import { EmptyState } from '@/components/common/EmptyState';

export const DashboardPage = () => {
  const navigate = useNavigate();
  const { profile } = useAuth();

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Welcome back{profile?.displayName ? `, ${profile.displayName}` : ''}!
        </Typography>
        <Typography color="text.secondary">
          Manage your feedback, support tickets, and feature requests
        </Typography>
      </Box>

      {/* Quick Stats */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" variant="body2">
                Open Tickets
              </Typography>
              <Typography variant="h4" fontWeight="bold">
                0
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" variant="body2">
                Feedback This Week
              </Typography>
              <Typography variant="h4" fontWeight="bold">
                0
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" variant="body2">
                Feature Requests
              </Typography>
              <Typography variant="h4" fontWeight="bold">
                0
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" variant="body2">
                KB Articles
              </Typography>
              <Typography variant="h4" fontWeight="bold">
                0
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Quick Actions */}
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
        Quick Actions
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card
            sx={{ cursor: 'pointer', '&:hover': { boxShadow: 3 } }}
            onClick={() => navigate('/app/tickets')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <Feedback color="primary" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="subtitle1" fontWeight="medium">
                View Tickets
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card
            sx={{ cursor: 'pointer', '&:hover': { boxShadow: 3 } }}
            onClick={() => navigate('/app/articles')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <Article color="primary" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="subtitle1" fontWeight="medium">
                Knowledge Base
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card
            sx={{ cursor: 'pointer', '&:hover': { boxShadow: 3 } }}
            onClick={() => navigate('/app/features')}
          >
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <RocketLaunch color="primary" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="subtitle1" fontWeight="medium">
                Feature Requests
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Card sx={{ cursor: 'pointer', '&:hover': { boxShadow: 3 } }}>
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <Add color="primary" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="subtitle1" fontWeight="medium">
                New Project
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Recent Activity - Empty State for now */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
          Recent Activity
        </Typography>
        <Card>
          <EmptyState
            title="No recent activity"
            description="Once you start receiving feedback, it will appear here."
          />
        </Card>
      </Box>
    </Box>
  );
};
